import Global from './../shared/global';
const $ = jQuery.noConflict();

'use strict';
const equalHeightsItems = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeight();
	},

	/** @description slider example description e.g Banner slider */
	equalHeight: () => {
		/* Global.equalHeights($('.js-map-counter')); */
		Global.equalHeights($('.js-simple-block'));
		Global.equalHeights($('.js-step-item'));
		Global.equalHeights($('.map__item-inner'));

		$(window).on('resize', function() {
			/* Global.equalHeights($('.js-map-counter')); */
			Global.equalHeights($('.js-simple-block'));
			Global.equalHeights($('.js-step-item'));
			Global.equalHeights($('.map__item-inner'));
		});

		if (window.innerWidth < 991 && window.innerWidth > 640) {
			Global.equalHeights($('.cards__content'));
			Global.equalHeights($('.cards__inner-title'));
			Global.equalHeights($('.magazine-cards__inner-title'));
			Global.equalHeights($('.customer-guides__inner-title'));
			Global.equalHeights($('.resources-company__card--title'));
			Global.equalHeights($('.js-vegetable-insect-card-title'));

			$(window).on('resize', function() {
				Global.equalHeights($('.cards__content'));
				Global.equalHeights($('.cards__inner-title'));
				Global.equalHeights($('.magazine-cards__inner-title'));
				Global.equalHeights($('.customer-guides__inner-title'));
				Global.equalHeights($('.resources-company__card--title'));
				Global.equalHeights($('.js-vegetable-insect-card-title'));
			});
		}

		if (window.innerWidth < 991) {
			Global.equalHeights($('.js-vertical-sliders-item'));
			Global.equalHeights($('.js-map-counter-holder'));

			$(window).on('resize', function() {
				Global.equalHeights($('.js-vertical-sliders-item'));
				Global.equalHeights($('.js-map-counter-holder'));
			});
		}

		if (window.innerWidth > 680) {
			Global.equalHeights($('.js-cards-content'));
			Global.equalHeights($('.boxes__inner-title'));
			Global.equalHeights($('.boxes__inner-text'));
			Global.equalHeights($('.js-main-cards-name'));
			Global.equalHeights($('.js-cards-member'));
			Global.equalHeights($('.js-member-cards-name'));
			Global.equalHeights($('.js-member-cards-member'));
			Global.equalHeights($('.js-apply-cards-title'));
			Global.equalHeights($('.js-vegetable-insect-card-title'));
			Global.equalHeights($('.js-same-height'));
			Global.equalHeights($('.js-cards-content-text'));

			$(window).on('resize', function() {
				Global.equalHeights($('.js-cards-content'));
				// Global.equalHeights($('.js-boxes-cards'));
				Global.equalHeights($('.js-main-cards-name'));
				Global.equalHeights($('.js-cards-member'));
				Global.equalHeights($('.js-member-cards-name'));
				Global.equalHeights($('.js-member-cards-member'));
				Global.equalHeights($('.js-apply-cards-title'));
				Global.equalHeights($('.js-vegetable-insect-card-title'));
				Global.equalHeights($('.js-same-height'));
				Global.equalHeights($('.js-cards-content-text'));
			});
		}

		if (window.innerWidth > 639) {
			Global.equalHeights($('.js-blog-cards-inner'));
			Global.equalHeights($('.cards__inner-title'));
			Global.equalHeights($('.magazine-cards__inner-title'));
			Global.equalHeights($('.customer-guides__inner-title'));
			Global.equalHeights($('.resources-company__card--title'));
			Global.equalHeights($('.js-vegetable-insect-card-title'));

		}
	},
};

export default equalHeightsItems;